<div class="container">
    <div class="header">
        <app-button
            class="new-button"
            text="system-settings.ops.add-button.text"
            [iconButton]="true"
            [noneMarginIcon]="true"
            iconSize="20px"
            icon="plus"
            [disable]="opsUnitList?.length >= OPS_UNIT_MAX || !canEditSettings"
            (onClick)="createOpsSetting()"
            customFontSize="14px"
            customFontFamily="NotoSans-SemiBold"></app-button>
        <span class="description">
            {{
                (opsUnitList?.length >= OPS_UNIT_MAX
                    ? 'system-settings.ops.limit-reached'
                    : 'system-settings.ops.description'
                ) | translate: { num: OPS_UNIT_MAX - 1 - opsUnitList?.length || 0 }
            }}
        </span>
    </div>
    <div class="table" *ngIf="opsUnitList.length">
        <div class="row table-header">
            <div class="cell table-header">
                {{ 'system-settings.ops.table-header.ops' | translate }}
            </div>
            <div class="cell table-header">
                {{ 'system-settings.ops.table-header.location' | translate }}
            </div>
            <div class="cell table-header">
                {{ 'system-settings.ops.table-header.category' | translate }}
            </div>
            <div class="cell table-header">
                {{ 'system-settings.ops.table-header.a-line-ip' | translate }}
            </div>
            <div class="cell table-header">
                {{ 'system-settings.ops.table-header.b-line-ip' | translate }}
            </div>
            <div></div>
        </div>
        <div class="row" data-cy="ops-settings-system-setting-ops-row" *ngFor="let opsUnit of opsUnitList; index as i">
            <div class="cell ops-number" data-cy="ops-settings-system-setting-ops-row-ops-number">
                {{ opsUnit.index }}
            </div>
            <div class="cell">
                <div class="location-wrapper">
                    <mat-icon svgIcon="location"></mat-icon>
                    <span class="location-text" data-cy="ops-settings-system-setting-ops-row-ops-name">{{
                        opsUnit.location
                    }}</span>
                </div>
            </div>
            <div class="cell">
                <div class="category-wrapper">
                    <mat-icon svgIcon="alarm"></mat-icon>
                    <span class="category-text" data-cy="ops-settings-system-setting-ops-row-ops-category">
                        {{ createMultiInputStr(opsUnit) }}
                    </span>
                </div>
            </div>
            <div class="cell ip" data-cy="ops-settings-system-setting-ops-row-ops-line-a-ip">
                {{ opsUnit.LineAIp }}
            </div>
            <div class="cell ip" data-cy="ops-settings-system-setting-ops-row-ops-line-b-ip">
                {{ opsUnit.LineBIp }}
            </div>
            <div
                class="cell options"
                [class.disabled]="!canEditSettings"
                [class.selected]="isOpenOption && selectedOpsUnit?.id === opsUnit.id"
                (click)="openMoreOption(opsUnit); $event.stopImmediatePropagation()">
                <mat-icon
                    class="more-icon"
                    data-cy="ops-settings-system-setting-ops-kebab-icon"
                    svgIcon="more-options"></mat-icon>
                <div class="options-dialog" [class.show]="isOpenOption && selectedOpsUnit?.id === opsUnit.id">
                    <div
                        class="options-item"
                        [class.disabled]="isEditDisabled(opsUnit)"
                        (click)="editOpsSetting(opsUnit, i)">
                        {{ 'dlg.edit' | translate }}
                    </div>
                    <div
                        class="options-item"
                        [class.disabled]="isDuplicateDisabled(opsUnit)"
                        (click)="duplicateOpsUnit()">
                        {{ 'system-settings.ops.more-option.duplicate' | translate }}
                    </div>
                    <div class="options-item" [class.disabled]="isDeleteDisabled(opsUnit)" (click)="deleteOpsUnit()">
                        {{ 'system-settings.ops.more-option.delete' | translate }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-confirmation-window
    #deleteDialog
    [subLabel]="'system-settings.ops.delete.sub.message'"
    [mainLabel]="deleteDialogMainLabel"
    [discardLabel]="'dlg.cancel'"
    [saveLabel]="'dlg.confirm'"
    [allButtonsLeft]="true"
    [inverseColors]="true"></app-confirmation-window>

<app-loading-spinner *ngIf="isLoading" class="spinner-component"></app-loading-spinner>
